/* import __COLOCATED_TEMPLATE__ from './logo-upload-image-component.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Component from '@glimmer/component';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { inject as service } from '@ember/service';
import RouteRegexes from 'embercom/lib/route-regexes';
export default class LogoUploadImageComponent extends Component {
  @service router;
  @service messengerSettingsThemeProvider;
  @service appService;

  get activeBrand() {
    return this.args.lookAndFeelSettings.activeBrand;
  }

  get selectedTheme() {
    return this.messengerSettingsThemeProvider.targetThemeType;
  }

  getThemeProperty(lightProperty, darkProperty) {
    return this.selectedTheme === 'dark' ? darkProperty : lightProperty;
  }

  get brandLogoUrlProperty() {
    if (this.args.launcherVariant) {
      return this.getThemeProperty('launcherLogoUrl', 'launcherLogoDarkUrl');
    }
    return this.getThemeProperty('messengerLogoUrl', 'messengerLogoDarkUrl');
  }

  get logoUrl() {
    return this.activeBrand && this.activeBrand[this.brandLogoUrlProperty];
  }

  get headerBackgroundImageStyle() {
    if (this.selectedTheme === 'dark') {
      return `background-image: url(${this.args.lookAndFeelSettings.activeBrand.backgroundImageDarkUrl})`;
    }
    return `background-image: url(${this.args.lookAndFeelSettings.activeBrand.backgroundImageUrl})`;
  }

  get isEditingMessenger() {
    return this.router.currentRouteName?.match(RouteRegexes.newSettings.messenger.root);
  }

  get headerStyle() {
    if (this.args.lookAndFeelSettings.activeBrand.showBackgroundImage) {
      return sanitizeHtml(this.headerBackgroundImageStyle);
    } else {
      return '';
    }
  }
}
